import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL;

export const fetchNews = async () => {
    const response = await axios.get(`${API_URL}/api/v1/articles`);
    return response;
};

export const fetchNewsDetail = async (article_id) => {
    const response = await axios.get(`${API_URL}/api/v1/articles?article_id=${article_id}`);
    return response;
};

export const fetchArticleRegionCategory = async (article_id) => {
    const response = await axios.get(`${API_URL}/api/v1/article_region_category?article_id=${article_id}`);
    return response;
};

export const fetchArticleIndustryCategory = async (article_id) => {
    const response = await axios.get(`${API_URL}/api/v1/article_industry_category?article_id=${article_id}`);
    return response;
};

export const keywordSearchNews = async (keyword) => {
    const response = await axios.get(`${API_URL}/api/v1/search_articles?keyword=${encodeURIComponent(keyword)}`);
    return response;
};
